import { useSelector, useDispatch } from 'react-redux';
import { clearActivePreview } from '../../redux/aiInsights/ai.actions';
import { useState, useEffect } from 'react';
export default function ThumbnailPreview() {
  const dispatch = useDispatch();
  const { previewImages, activePreviewId } = useSelector(
  (state) => state.aiInsights
);

const previewImage = activePreviewId
  ? previewImages?.[activePreviewId]
  : null;

  const [, setIsZoomed] = useState(false);
  const [isZoomOpen, setIsZoomOpen] = useState(false);

  useEffect(() => {
    setIsZoomed(false);
  }, [previewImage]);
  //console.log("previewImage", previewImage)
  if (!previewImage) return null;

  return (
    <div >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
        <h6 className="mb-0">Insight Images</h6>
        <button className="btn-close" onClick={() => dispatch(clearActivePreview())} />
      </div>

      {/* Image */}
      {/* Image */}
      <div className="p-3 h-100 text-center ">
        <div className="position-relative preview-image-wrapper">
          {/* Hover Zoom Button */}
          <button
            className="btn btn-light btn-sm zoom-btn"
            onClick={() => setIsZoomOpen(true)}
            title="Click to enlarge">
            <i className="material-icons">zoom_out_map</i>
          </button>

          <img
            src={previewImage}
            alt="Insight graph"
            className="img-fluid rounded shadow"
            draggable={false}
          />
        </div>
      </div>
      {isZoomOpen && (
        <div className="modal fade show d-block"  style={{ backgroundColor: 'rgb(254 245 245)' }}>
          <div className="modal-dialog modal-fullscreen" onClick={() => setIsZoomOpen(false)}>
            <div className="modal-content bg-light">
              {/* Header */}
              <div className="modal-header border-0">
                <h6 className="modal-title text-white">Insight Graph</h6>
                <button
                  className="btn-close btn-close-black"
                  onClick={() => setIsZoomOpen(false)}
                />
              </div>

              {/* Image */}
              <div className="modal-body d-flex align-items-center justify-content-center overflow-auto">
               <img
  src={previewImage}
  alt="Zoomed Insight"
  className="img-fluid rounded shadow"
  style={{
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    paddingBottom: "40px"
  }}
/>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
